import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useToaster } from '@/components/base/toaster';

export type IndeedConnectOutcome =
  | 'connected'
  | 'connected_settings_failed'
  | 'not_connected';

const messages = defineMessages({
  connected: {
    defaultMessage: 'Indeed account connected.',
    description:
      'Confirms the employer connected their Indeed account to Fountain',
  },
  connected_settings_failed: {
    defaultMessage:
      "Indeed account connected. We couldn't save your settings. Open Configure to try them again.",
    description:
      'Indeed authorization succeeded but saving the employer’s feed settings failed; Configure retries those settings',
  },
  not_connected: {
    defaultMessage: "Indeed wasn't connected. Nothing was saved.",
    description:
      'The employer cancelled Indeed authorization or it timed out without saving anything',
  },
});

export function indeedConnectToasts(outcome: IndeedConnectOutcome) {
  const notify = {
    connected: 'notifySuccess',
    connected_settings_failed: 'notifyError',
    not_connected: 'notifyInfo',
  } as const;
  return { notify: notify[outcome], message: messages[outcome] };
}

export function useIndeedConnectToasts() {
  const intl = useIntl();
  const toaster = useToaster();
  return useCallback(
    (outcome: IndeedConnectOutcome) => {
      const { notify, message } = indeedConnectToasts(outcome);
      toaster[notify]({ message: intl.formatMessage(message) });
    },
    [intl, toaster],
  );
}
